import { reject } from 'lodash';
import { ASSIGN_PAYMENTS, REMOVE_PAYMENT } from './constants';
import { RESET } from '../../constants';

const initialPayments = [];
const payments = (state = initialPayments, { type, payload }) => {
  switch (type) {
    case RESET:
      return initialPayments;
    case ASSIGN_PAYMENTS:
      return payload;
    case REMOVE_PAYMENT:
      return reject(state, { id: payload });
    default:
      return state;
  }
};

export default payments;
